import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'checkpoint',
        loadChildren: () =>
          import('./checkpoint/checkpoint.module').then((m) => m.CheckpointModule),
      },
      {
        path: 'status',
        loadChildren: () => import('./status/status.module').then((m) => m.StatusModule),
      },
      {
        path: 'app-configuration',
        loadChildren: () =>
          import('./app-configuration/app-configuration.module').then(
            (m) => m.AppConfigurationModule
          ),
      },
      {
        path: 'message',
        loadChildren: () => import('./message/message.module').then((m) => m.MessageModule),
      },
      {
        path: 'access-log',
        loadChildren: () => import('./access-log/access-log.module').then((m) => m.AccessLogModule),
      },
      {
        path: 'records',
        loadChildren: () => import('./records/records.module').then((m) => m.RecordsModule),
      },
      {
        path: 'card-extension',
        loadChildren: () =>
          import('./card-extension/card-extension.module').then((m) => m.CardExtensionModule),
      },
      {
        path: 'upload',
        loadChildren: () => import('./upload/upload.module').then((m) => m.UploadModule),
      },
      {
        path: 'measures',
        loadChildren: () => import('./measures/measures.module').then((m) => m.MeasuresModule),
      },
      {
        path: 'jobs',
        loadChildren: () => import('./jobs/jobs.module').then((m) => m.JobsModule),
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'price-list',
        loadChildren: () => import('./price-list/price-list.module').then((m) => m.PriceListModule),
      },
      {
        path: 'payments',
        loadChildren: () => import('./payments/payments.module').then((m) => m.PaymentsModule),
      },
      {
        path: 'ticket-office',
        loadChildren: () =>
          import('./ticket-office/ticket-office.module').then((m) => m.TicketOfficeModule),
      },
      {
        path: 'contracts',
        loadChildren: () => import('./contracts/contracts.module').then((m) => m.ContractsModule),
      },
      {
        path: 'item',
        loadChildren: () => import('./item/item.module').then((m) => m.ItemModule),
      },
      {
        path: 'item-bill',
        loadChildren: () => import('./item-bill/item-bill.module').then((m) => m.ItemBillModule),
      },
      {
        path: 'bill-list',
        loadChildren: () => import('./bill-list/bill-list.module').then((m) => m.BillListModule),
      },
      {
        path: 'costs',
        loadChildren: () => import('./costs/costs.module').then((m) => m.CostsModule),
      },
      {
        path: 'keys',
        loadChildren: () => import('./keys/keys.module').then((m) => m.KeysModule),
      },
      {
        path: 'locations',
        loadChildren: () => import('./locations/locations.module').then((m) => m.LocationsModule),
      },
      {
        path: 'cost-codes',
        loadChildren: () => import('./cost-codes/cost-codes.module').then((m) => m.CostCodesModule),
      },
      {
        path: 'business',
        loadChildren: () => import('./business/business.module').then((m) => m.BusinessModule),
      },
      {
        path: 'trainer',
        loadChildren: () => import('./trainer/trainer.module').then((m) => m.TrainerModule),
      },
      {
        path: 'working-hours',
        loadChildren: () =>
          import('./working-hours/working-hours.module').then((m) => m.WorkingHoursModule),
      },
      {
        path: 'keys-list',
        loadChildren: () => import('./keys-list/keys-list.module').then((m) => m.KeysListModule),
      },
      {
        path: 'partner',
        loadChildren: () => import('./partner/partner.module').then((m) => m.PartnerModule),
      },
      {
        path: 'utility',
        loadChildren: () => import('./utility/utility.module').then((m) => m.UtilityModule),
      },
      {
        path: 'cost-type',
        loadChildren: () => import('./cost-type/cost-type.module').then((m) => m.CostTypeModule),
      },
      {
        path: 'open-items',
        loadChildren: () => import('./open-items/open-items.module').then((m) => m.OpenItemsModule),
      },
      {
        path: 'complimentary/:id',
        loadChildren: () =>
          import('./complimentary/complimentary.module').then((m) => m.ComplimentaryModule),
      },
      {
        path: 'params',
        loadChildren: () => import('./params/params.module').then((m) => m.ParamsModule),
      },
    ]),
  ],
})
export class EntitiesModule {}
